import * as React from 'react'
import { withNamespaces } from 'react-i18next'
import { connect } from 'react-redux'
import {
    Modal,
    ModalHeader,
    ModalBody
} from 'reactstrap'
import Spinner from 'react-bootstrap/Spinner'
import EntityManagementService from '../../../../../../api/EntityManagementService'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'react-toastify'

const UploadExcelButton = ({ t, onSuccess }) => {
    const service = new EntityManagementService()
    
    const uploadMutation = useMutation({
        mutationKey: ['entity-management-upload-excel'],
        mutationFn: (file) => {
            const formData = new FormData()
            
            formData.append('file', file)

            return service.uploadExcel(formData)
        },
        onSuccess: () => {
            onSuccess && onSuccess()

            toast(t('Excel uploaded successfully.'), {
				type: 'success'
			})
        },
        onError: () => {
            toast(t('An error occured while uploading the excel file.'), {
				type: 'error'
			})
        }
    })

    const openUploadDialog = (onFilePicked) => {
        const inputElemenet = document.createElement("input")
        inputElemenet.style.display = "none"
        inputElemenet.type = "file"
        inputElemenet.accept = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    
        inputElemenet.addEventListener("change", () => {
            if (inputElemenet.files) {
                onFilePicked(inputElemenet.files[0])
            }
        })
    
        const teardown = () => {
            document.body.removeEventListener("focus", teardown, true)
            setTimeout(() => {
                document.body.removeChild(inputElemenet)
            }, 1000)
        }

        document.body.addEventListener("focus", teardown, true)
    
        document.body.appendChild(inputElemenet)
        inputElemenet.click()
    }

    const handleUploadExcel = () => {
        openUploadDialog((file) => {
            uploadMutation.mutate(file)
        })
    }

    const showModal = uploadMutation.isFetching || uploadMutation.isLoading

    return (
        <React.Fragment>
            <div
                onClick={handleUploadExcel}
            >
                <i className='ri-upload-line align-middle me-1' />
                {t('Upload Excel')}
            </div>

            <Modal isOpen={ showModal }>
                <ModalHeader>
                    <div>
                        <Spinner className="me-2" animation="border" variant="info" size="sm"/>
                        {t('Uploading...')}
                    </div>
                </ModalHeader>
                
                <ModalBody>
                    {t("This might take several minutes.please don't close or refresh the page")}
                </ModalBody>
            </Modal>
        </React.Fragment>
    )
}

const mapToState = (state) => {
    const { token } = state.Login

    return {
        token
    }
}

export default withNamespaces()(
    connect(mapToState, {})(
        UploadExcelButton
    )
)